// Quote — DS §4.8 (.quote). Source Serif italic 16, 3px left rule, role tint.

export type QuoteRole = "default" | "warning" | "danger" | "info" | "success";

export interface QuoteProps {
    role?: QuoteRole;
    text: string;
    attribution?: string;
}

const ROLE: Record<QuoteRole, string> = {
    default: "bg-muted border-l-ink-faint",
    warning: "bg-warning-bg border-l-warning",
    danger: "bg-danger-bg border-l-danger",
    info: "bg-info-bg border-l-info",
    success: "bg-success-bg border-l-success",
};

export function Quote({ role = "default", text, attribution }: QuoteProps) {
    return (
        <blockquote className={`rounded-r-[var(--radius-sm)] border-l-[3px] px-4 py-4 ${ROLE[role]}`}>
            <p className="font-serif text-base font-medium italic leading-[1.55] text-primary">
                {text}
            </p>
            {attribution && (
                <div className="mt-2 flex items-center gap-2 font-sans text-xs leading-[1.4] text-secondary">
                    {attribution}
                </div>
            )}
        </blockquote>
    );
}
